import { jsonSafeParse } from 'api';
import { apiHolder } from 'api';
const dataStoreApi = apiHolder.api.getDataStoreApi();
const POPUP_KEYS = 'all_popups';
function mergeLocalData(valueFromDB, state) {
    Object.keys(valueFromDB).forEach(key => {
        const stateElement = state[key];
        const valueFromDBElement = valueFromDB[key];
        if (stateElement) {
            state[key] = Object.assign(Object.assign({}, valueFromDBElement), stateElement);
            state[key].lastUpdateTime = Date.now();
        }
        else {
            if (!valueFromDBElement.lastUpdateTime || Date.now() - valueFromDBElement.lastUpdateTime < 180 * 24 * 3600000) {
                state[key] = valueFromDBElement;
            }
        }
    });
}
export const putValueToDB = async (state) => {
    if (!state || Object.keys(state).length === 0) {
        return;
    }
    const valueFromDB = await getValueFromDB();
    const result = Object.assign({}, state);
    if (valueFromDB && Object.keys(valueFromDB).length > 0) {
        mergeLocalData(valueFromDB, result);
    }
    const data = JSON.stringify(result);
    console.log('[popup_state] putValueToDB ', data);
    return await dataStoreApi.putToDB(POPUP_KEYS, data);
};
export const getValueFromDB = async () => {
    const storeData = await dataStoreApi.getFromDB(POPUP_KEYS);
    if (storeData && storeData.data) {
        const parse = jsonSafeParse(storeData.data);
        return parse;
    }
    return null;
};
